import { DirectiveOptions } from "vue/types/options";

export const touchDirective: DirectiveOptions = {
  bind: (el: HTMLElement): void => {
    el.addEventListener(
      "touchstart",
      () => {
        el.setAttribute("touched", "");
      },
      false
    );
    el.addEventListener(
      "touchend",
      () => {
        el.removeAttribute("touched");
      },
      false
    );
  },
};
